import { Component, OnInit } from '@angular/core';
import {RegistrationService} from "../../services/registration-service";
import {HttpClient} from "@angular/common/http";
import {HTTPCONSTANTS} from "../../http/http-constants";

@Component({
  selector: 'pla-about-us-page',
  templateUrl: './about-us-page.component.html',
  styleUrls: ['./about-us-page.component.scss']
})
export class AboutUsPageComponent implements OnInit {

  public priceCount: number = 0;
  public plateCount: number = 0;
  public searchesThisWeek: number = 0;
  public comparesToday: number = 0;

  constructor(private registrationService: RegistrationService, private httpClient: HttpClient) {
    this.registrationService
      .getPlateCount()
      .subscribe((_: { totalCount: number }) => {
        this.plateCount = _.totalCount;
        this.priceCount = Number.parseFloat(((this.plateCount * 45) / 100000000).toFixed(1));
      });
  }

  ngOnInit(): void {
    this.GetWeeklySearches();
  }

  private GetWeeklySearches() {
    this.httpClient.get(`${HTTPCONSTANTS.plato_search_protocol}${HTTPCONSTANTS.plato_search_base}?process=search-tracking-about-us`).subscribe((res: { searchesThisWeek: number, comparesToday: number }) => {
      this.searchesThisWeek = res.searchesThisWeek;
      this.comparesToday = res.comparesToday;
    });
  }
}
